import { Action } from 'redux';
import { Schema, SchemaField } from '../../types/Metadata';
import { NodeType } from '../../enums/NodeType';
import { Page } from '../../enums/Page';

const v: Schema = null;
type SchemaProps = typeof v.props;

export interface SchemaModalState extends Partial<Omit<SchemaProps, 'type'>> {
  nodeType?: NodeType;
  page?: Page;
  selectedField?: string;
  loading?: boolean;
  error?: string;
  additionalInfo?: AdditionalInfo[];
  schemaForms?: Schema[];
}

export interface AdditionalInfo {
  field: string;
  message: string;
}

const UPDATE_SCHEMA_MODAL_STATE = 'UPDATE_SCHEMA_MODAL_STATE';

export const updateSchemaModalState = (newState: Partial<SchemaModalState>) => {
  if (newState.additionalInfo) {
    if (!Array.isArray(newState.additionalInfo)) {
      newState.additionalInfo = [newState.additionalInfo];
    }
  }
  return {
    ...newState,
    type: UPDATE_SCHEMA_MODAL_STATE
  };
};

type SchemaModalAction = Action & Partial<SchemaModalState>;

const schemaModalReducer = (
  state: SchemaModalState = {},
  action: SchemaModalAction
): SchemaModalState => {
  const { type, ...newState } = action;
  switch (type) {
    case UPDATE_SCHEMA_MODAL_STATE:
      if (newState.page === null) {
        return {};
      }
      return { ...state, ...newState };
    default:
      return state;
  }
};

export default schemaModalReducer;
